import React from "react";
import LeftContent from "components/infos/LeftContent";
import RightContent from "components/infos/RightContent";

const MainContent = (props) => {
  let userData = window.$user_profile;
  let isCannotEdit =
    userData?.user_sess?.userCanAccessEmployees
      ? false
      : true;
  if (isCannotEdit) {
    return (
      <div style={{ padding: "50px 0", textAlign: "center" }}>
        <h3>
          You do not have permission to access this profile page. Only profile
          owners, HR admins, and system administrators can view it.
        </h3>
        <h5 style={{ marginTop: "10px" }}>
          If you believe you should have access, please contact the
          administrators
        </h5>
        <a href="/employees/" style={{ fontSize: "18px" }}>
          Go to EXO24
        </a>
      </div>
    );
  }
  return (
    <div id="profile-content" className="inner-container row">
      <LeftContent userData={userData} />
      <RightContent userData={userData} />
    </div>
  );
};

export default MainContent;
